import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Fires a virtual PageView on every SPA route change after the initial render.
 *
 * The first render is skipped intentionally:
 *   - Meta Pixel fires its own PageView via fbq('track', 'PageView') in index.html
 *   - GA4 fires its own page_view via gtag('config', ..., { send_page_view: true }) in index.html
 * Calling trackPageView() on the first render would double-count the landing page.
 *
 * Must be used inside a component that is a child of <BrowserRouter>.
 */
export function useRouteTracking(): void {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
}
